import React, { useEffect, useState } from 'react'
import axios from 'axios'
import { toast } from 'react-toastify';
import Cookies from 'js-cookie';
import sha256 from 'crypto-js/sha256';
import img5 from '../images/shutterstock_1039074919.webp'
import { useTranslation } from 'react-i18next';
import Cropper from 'react-easy-crop';

function LinksEdit({ dragHandleProps }) {
  const { t } = useTranslation();
  let LanguageSelected = Cookies.get('LanguageSelected');

  const apiUrl = process.env.REACT_APP_BACKEND_URL


  let ImageUrl = process.env.REACT_APP_IMAGES_URL

  let userId = Cookies.get('userId');
  let UserToken = Cookies.get('UserSpecialToken');
  const hashedUserId = sha256((String(userId)));

  const [Done, setDone] = useState(false)
  const [InputsErrors, setInputsErrors] = useState([])


  const [LinksModal, setLinksModal] = useState(false)
  const [EditLinksModal, setEditLinksModal] = useState(false)
  const [editImage, seteditImage] = useState(false)

  const [isFetching, setIsFetching] = useState(false);

  const [LinksInfo, setLinksInfo] = useState({
    title: { fr: '', en: '', ar: '' },
  description: { fr: '', en: '', ar: '' },
  url: '',
image:''
  })
  const [LinksContent, setLinksContent] = useState([])

  const [LinksId, setLinksId] = useState()

  const AddingLinksInfo = (e) => {
    const { name, value } = e.target;
    if(name.includes('-')){
      const [field,lang]=name.split('-');
        const currentFieldValue = LinksInfo[field];
        if(typeof currentFieldValue === 'object' && currentFieldValue !== null){

        setLinksInfo(prev=>({
          ...prev,
          [field]:{
            ...prev[field],
            [lang]:value
          }
        }));
      }
      }else{
      setLinksInfo(prev => ({ ...prev, [name]: value }));
      }
  }
  



  function compressImage(file) {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onload = (event) => {
        const img = new Image();
        img.src = event.target.result;

        img.onload = () => {
          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');
          const maxWidth = 800; // Set your desired max width
          const maxHeight = 600; // Set your desired max height
          let newWidth = img.width;
          let newHeight = img.height;

          if (img.width > maxWidth || img.height > maxHeight) {
            const aspectRatio = img.width / img.height;
            if (aspectRatio > 1) {
              newWidth = maxWidth;
              newHeight = maxWidth / aspectRatio;
            } else {
              newHeight = maxHeight;
              newWidth = maxHeight * aspectRatio;
            }
          }

          canvas.width = newWidth;
          canvas.height = newHeight;
          ctx.drawImage(img, 0, 0, newWidth, newHeight);

          canvas.toBlob((blob) => {
            resolve(new File([blob], file.name, { type: file.type }));
          }, file.type, 0.7); // Adjust compression quality here (0.7 = 70%)
        };
      };
      reader.readAsDataURL(file);
    });
  }

  const AddingLinkInfoImage = async (e) => {
    let Picture = e.target.files[0]
    if (!Picture) {
      toast.error('No image selected');
      return;
    }

    const allowedExtensions = ['png', 'jpg', 'jpeg', 'gif'];
    const maxSize = 20 * 1024 * 1024; // 20 MB in bytes

    const extension = Picture.name.split('.').pop().toLowerCase();
    if (!allowedExtensions.includes(extension)) {
      toast.error('Invalid image format. Allowed formats: PNG, JPG, JPEG, GIF');
      return;
    }

    if (Picture.size > maxSize) {
      toast.error('Image size exceeds 20 MB');
      return;
    }

    handleImageCrop(e, Picture)
  };


  const SetLinksToUpdateDefaultValues = (id) => {
    const links = LinksContent.find(link => link.id === id)
    return setLinksInfo({ ...LinksInfo, 
      LinksId: id,
       title: links?.title || {fr:'', en:'', ar:''}, 
       description: links?.description || {fr:'', en:'', ar:''}, 
       url: links.url 
      })

  }

  useEffect(() => {
    fetch(`${apiUrl}/GetLinksInfo`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        'Authorization': `Bearer ${UserToken}`


      },
      body: JSON.stringify({ user_id: userId })


    })
      .then(response => response.json())
      .then(result => {
        if (result.success) {
          setLinksContent(result.data)


        }
      })
  }, [Done])

  const StoreLinksInfo = (e) => {
    setIsFetching(true);

    e.preventDefault()
    axios
      .post(`${apiUrl}/StoreLinksInfo`, LinksInfo, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${UserToken}`,
        },
      }).then(result => {
        if (result.data.success) {
          setLinksInfo('')
          setDone(!Done)
          setInputsErrors([])
          setImageToCrop(null)
          setCroppedImage(null)
          setCropImage(false)
          setLinksModal(false)
          setZoom(1)

          toast.success(result.data.message, {
            position: toast.POSITION.CENTER
          });

        }
        else {
          setInputsErrors(result.data.errors)

        }
      })
      .finally(() => {
        setIsFetching(false);
      });


  }

  const UpdateLinksInfo = (e) => {
    setIsFetching(true);

    e.preventDefault()
    axios
      .post(`${apiUrl}/UpdateLinksInfo`, LinksInfo, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${UserToken}`,
        },
      })
      .then(result => {
        if (result.data.success) {
          setLinksInfo('')
          setInputsErrors([])
          setDone(!Done)
          setZoom(1)

          seteditImage(false);
          setImageToCrop(null)
          setCroppedImage(null)
          setEditLinksModal(false)
          setCropImage(false)
          toast.success(result.data.message, {
            position: toast.POSITION.CENTER
          });

        }
        else {
          setInputsErrors(result.data.errors)

        }
      })
      .finally(() => {
        setIsFetching(false);
      });
  }

  const DeleteLinksInfo = (e, id,lang) => {
    e.preventDefault()

    fetch(`${apiUrl}/DeleteLinksInfo`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        'Authorization': `Bearer ${UserToken}`


      },
      body: JSON.stringify({ LinksId: id,lang:lang })
    })
      .then(response => response.json())
      .then(result => {
        if (result.success) {
          setDone(!Done)
        toast.success(result.message, { position: toast.POSITION.CENTER });


        }else {
        toast.error(result.message || 'Delete failed');
      }

      })
       .catch(error => {
      console.error('Delete error:', error);
      toast.error('Error deleting service: ' + error.message);
    });

  }


  const [CropImage, setCropImage] = useState(false);
  const [zoom, setZoom] = useState(1);
  const [croppedImage, setCroppedImage] = useState(null);
  const [crop, setCrop] = useState({ x: 0, y: 0 });

  useEffect(() => {
    if (LinksModal || EditLinksModal || CropImage) {
      document.body.classList.add('modal-open');
    } else {
      document.body.classList.remove('modal-open');
    }
  }, [LinksModal,EditLinksModal,CropImage]);


  const [imageToCrop, setImageToCrop] = useState(null);

  const onCropChange = (crop) => {
    setCrop(crop);
  };

  const onZoomChange = (zoom) => {
    setZoom(zoom);
  };



  const handleImageCrop = (e, fileImage) => {
    const file = fileImage;

    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        setImageToCrop(reader.result);
      };
      reader.readAsDataURL(file);
    }

    // Set state to control UI, like showing cropped image or closing modal

    setCropImage(true);
  };

  const Base64Image = async () => {
    const croppedImageBase64 = await convertBlobToBase64(croppedImage);
    return setLinksInfo({ ...LinksInfo, Image: croppedImageBase64 }); // Assuming LinksInfo is your state object

  }

  const handleCropComplete = async (_, croppedAreaPixels) => {
    try {
      const croppedImageBlob = await getCroppedImageBlob(imageToCrop, croppedAreaPixels);
      const compressedFile = await compressImage(croppedImageBlob);
      setCroppedImage(compressedFile);

    } catch (error) {
      console.error('Error cropping image:', error);
    }
  };
  const convertBlobToBase64 = (blob) => {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onload = () => {
        resolve(reader.result);
      };
      reader.readAsDataURL(blob);
    });
  };


  const getCroppedImageBlob = (imageSrc, croppedAreaPixels) => {
    return new Promise((resolve) => {
      const image = new Image();
      image.src = imageSrc;
      const canvas = document.createElement('canvas');
      canvas.width = croppedAreaPixels.width;
      canvas.height = croppedAreaPixels.height;
      const ctx = canvas.getContext('2d');

      image.onload = () => {
        ctx.drawImage(
          image,
          croppedAreaPixels.x,
          croppedAreaPixels.y,
          croppedAreaPixels.width,
          croppedAreaPixels.height,
          0,
          0,
          croppedAreaPixels.width,
          croppedAreaPixels.height
        );
        canvas.toBlob((blob) => {
          resolve(blob);
        }, 'image/jpeg');
      };
    });
  };

  return (
  <div className={`${LanguageSelected == 'ar' ? 'rtlDiv' : ''}`}>
    <section className="links mt-2 sections rounded-xl pt-3 pb-3 pl-2 m-3">
      <div className="pb-2">
        <h1 className={`${LanguageSelected == 'ar' ? 'title title--h1 first-title title__separate text-theme right-4' : 'title left-0 title--h1 first-title title__separate text-theme'}`}>{t("Liens")}</h1>
      </div>
      <div className="pl-4 pr-4 w-full">
        <div className="grid grid-cols-1 gap-4">
          <div className="col-span-12 sm:col-span-6 md:col-span-3">
            {LinksContent != '' &&
              LinksContent.map((link, index) => {
                const currentTitle = link.title?.[LanguageSelected] || '';
                const currentDesc = link.description?.[LanguageSelected] || '';
                const isEmpty = !currentTitle.trim() && !currentDesc.trim();

                return (
                  <div className="relative flex flex-row div-sections rounded p-1 mt-4 mr-1" key={link.id}>
                    {isEmpty ? (
                      // Empty state - show placeholder
                      <div className="w-full p-3 flex flex-col items-center justify-center">
                        <div
                          className="w-20 h-16 flex justify-center items-center rounded-lg mb-2"
                          style={{
                            backgroundImage: `url(${link.image !== null ? `${ImageUrl}/${hashedUserId}/${link.image}` : img5})`,
                            backgroundSize: "cover",
                          }}
                        ></div>
                        <p className="text-gray-400 text-center mb-2">
                          {t("No translation available for")} {LanguageSelected.toUpperCase()}
                        </p>
                        <button
                          onClick={() => {
                            setEditLinksModal(true);
                            setLinksId(link.id);
                            SetLinksToUpdateDefaultValues(link.id);
                          }}
                          className="text-gold hover:underline font-semibold">
                          {t("Add translation")} →
                        </button>
                      </div>
                    ) : (
                      // Normal display with content
                      <div className="flex flex-col review-ite flex-none w-full md:w-1/2 lg:w-1/3">
                        <div className="flex flex-col -pb-2">
                          <a href={link.url} target='_blank' rel="noopener noreferrer" className="flex justify-between gap-2 items-center">
                            <div
                              className="w-1/3 flex justify-center items-center p-1 rounded-full"
                              style={{
                                backgroundImage: `url(${link.image !== null ? `${ImageUrl}/${hashedUserId}/${link.image}` : img5})`,
                                backgroundSize: "cover",
                                width: "6rem",
                                height: "4.5rem",
                              }}
                            ></div>

                            <div className='w-full justify-start pl-2 items-center'>
                              <h4 className={`text-theme title text-start leading-none title--h5 ${LanguageSelected == 'ar' ? 'pl-8 text-right' : 'pr-8 text-left'}`} dir={LanguageSelected === 'ar' ? 'rtl' : 'ltr'}>
                                {currentTitle || link.title?.fr || link.title?.en || t('Untitled')}
                              </h4>
                              <p className={`text-about text-theme ${LanguageSelected == 'ar' ? 'text-right' : 'text-left'}`} dir={LanguageSelected === 'ar' ? 'rtl' : 'ltr'}>
                                {currentDesc || link.description?.fr || link.description?.en || ''}
                              </p>
                            </div>
                          </a>
                        </div>
                      </div>
                    )}

                    {/* Edit and Delete buttons - always show */}
                    <div className={`${LanguageSelected == 'ar' ? 'flex items-center absolute left-2 top-2' : 'flex items-center absolute top-2 -right-4'}`}>
                      <svg 
                        onClick={() => { 
                          setEditLinksModal(true); 
                          setLinksId(link.id); 
                          SetLinksToUpdateDefaultValues(link.id) 
                        }} 
                        xmlns="http://www.w3.org/2000/svg" 
                        fill="none" 
                        viewBox="0 0 24 24" 
                        strokeWidth="1.5" 
                        stroke="currentColor" 
                        className="w-6 cursor-pointer hover:text-blue-500">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10" />
                      </svg>
                      
                      {!isEmpty && ( // Only show delete if there's content to delete
                        <svg 
                          onClick={(e) => { DeleteLinksInfo(e, link.id, LanguageSelected) }} 
                          xmlns="http://www.w3.org/2000/svg" 
                          fill="none" 
                          viewBox="0 0 24 24" 
                          strokeWidth="1.5" 
                          stroke="currentColor" 
                          className={`${LanguageSelected == 'ar' ? 'w-6 mr-0.5' : 'w-6 mr-5'} cursor-pointer hover:text-red-500`}>
                          <path strokeLinecap="round" strokeLinejoin="round" d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0" />
                        </svg>
                      )}
                    </div>
                  </div>
                );
              })
            }
          </div>
        </div>
      </div>

      <a onClick={() => { setLinksModal(true) }}>
        <main className="flex p-5 items-center justify-center">
          <label htmlFor="dropzone-file-input-links" className="mx-auto cursor-pointer flex w-full max-w-lg flex-col items-center rounded border-2 border-dashed border-gold div-sections p-6 text-center">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-6 h-6 text-theme">
              <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v6m3-3H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <p className="mt-2 text-about tracking-wide">{t("Entrez vos liens.")}</p>
          </label>
        </main>
      </a>

      <div className="drag-handle flex justify-center pt-2 text-theme" {...dragHandleProps}>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6">
          <path fillRule="evenodd" d="M17.303 5.197A7.5 7.5 0 006.697 15.803a.75.75 0 01-1.061 1.061A9 9 0 1121 10.5a.75.75 0 01-1.5 0c0-1.92-.732-3.839-2.197-5.303zm-2.121 2.121a4.5 4.5 0 00-6.364 6.364.75.75 0 11-1.06 1.06A6 6 0 1118 10.5a.75.75 0 01-1.5 0c0-1.153-.44-2.303-1.318-3.182zm-3.634 1.314a.75.75 0 01.82.311l5.228 7.917a.75.75 0 01-.777 1.148l-2.097-.43 1.045 3.9a.75.75 0 01-1.45.388l-1.044-3.899-1.601 1.42a.75.75 0 01-1.247-.606l.569-9.47a.75.75 0 01.554-.68z" clipRule="evenodd" />
        </svg>
      </div>
    </section>

    {/* Add Modal */}
    {LinksModal && (
      <div>
        <div className="minscreen h-full animated fadeIn faster fixed left-0 top-0 flex justify-center items-center inset-0 z-50 forms-info">
          <div className="absolute top-0 right-0 p-4">
            <a className='w-12 h-12' onClick={() => { setLinksModal(false); setCroppedImage(null); setImageToCrop(null); setInputsErrors([]) }}>
              <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-theme cursor-pointer" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M14.707 14.707a1 1 0 0 1-1.414 0L10 11.414l-3.293 3.293a1 1 0 1 1-1.414-1.414L8.586 10l-3.293-3.293a1 1 0 0 1 1.414-1.414L10 8.586l3.293-3.293a1 1 0 0 1 1.414 1.414L11.414 10l3.293 3.293a1 1 0 0 1 0 1.414z" />
              </svg>
            </a>
          </div>
          <div className="w-full max-w-sm p-8 rounded-md">
            <h2 className="text-3xl mb-2 text-theme">{t("Liens")}</h2>
            <form className="space-y-6 text-about">
              <div>
                <label htmlFor="image" className="textModal">{t("Entrez un lien vers un site ou un document hébergé pour permettre à vos réunions d'y accéder en un clic")}</label>
                {croppedImage && (
                  <div className='relative'>
                    <div className='w-44 h-44'>
                      <img className="cover w-full h-full preview-image border rounded-xl mt-4" src={URL.createObjectURL(croppedImage)} alt="Preview" />
                    </div>
                    <a onClick={() => { setCroppedImage(null); setImageToCrop(null); }}>
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 absolute right-1 top-1 text-white div-sections opacity-50 rounded-xl cursor-pointer" viewBox="0 0 20 20" fill="currentColor">
                        <path fillRule="evenodd" d="M14.707 14.707a1 1 0 0 1-1.414 0L10 11.414l-3.293 3.293a1 1 0 1 1-1.414-1.414L8.586 10l-3.293-3.293a1 1 0 0 1 1.414-1.414L10 8.586l3.293-3.293a1 1 0 0 1 1.414 1.414L11.414 10l3.293 3.293a1 1 0 0 1 0 1.414z" />
                      </svg>
                    </a>
                    <p className="mt-2 text-center text-red-600 dark:text-red-500"><span className="font-xsmall">{InputsErrors.hasOwnProperty('Image') && InputsErrors.Image}</span></p>
                  </div>
                )}

                <div className="flex items-center justify-center w-full">
                  {!croppedImage && (
                    <label htmlFor="dropzone-file-service" className="flex flex-col items-center justify-center w-full h-44 mt-5 border-2 border-gold border-dashed rounded-lg cursor-pointer div-sections">
                      <div className="flex flex-col items-center justify-center pt-5 pb-6">
                        <svg aria-hidden="true" className="w-10 h-10 mb-3 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"></path>
                        </svg>
                        <center><p className="mb-2 text-sm text-gray-300"><span className="font-semibold">{t("Cliquez pour télécharger")}</span></p></center>
                        <p className="text-xs text-gray-400">SVG, PNG, JPG or GIF (MAX. 800x400px)</p>
                        <p className="mt-2 text-center text-red-600 dark:text-red-500"><span className="font-xsmall">{InputsErrors.hasOwnProperty('Image') && InputsErrors.Image}</span></p>
                      </div>
                      <input onChange={(e) => { AddingLinkInfoImage(e) }} id="dropzone-file-service" type="file" name='Image' className="hidden" />
                    </label>
                  )}
                </div>

                <div className='mt-3'>
                  <div className="mt-5">
                    <input onChange={(e) => { AddingLinksInfo(e) }} type="text" name="url" className="appearance-none block w-full placeholder-sm px-3 py-2 bg-gray-700 border border-transparent rounded placeholder-gray-111 text-black focus:outline-none active sm:text-sm" placeholder={t("Entrer votre URL*")} required />
                    <p className="mt-2 text-red-600 dark:text-red-500"><span className="font-xsmall">{InputsErrors.hasOwnProperty('url') && InputsErrors.url}</span></p>
                  </div>
                </div>

                {/* Multi-language Title Input */}
                <div>
                  <div className="mt-5">
                    {LanguageSelected === 'fr' && (
                      <input 
                        value={LinksInfo.title?.fr || ''}
                        onChange={(e) => AddingLinksInfo(e)} 
                        type="text" 
                        name="title-fr" 
                        className="appearance-none block w-full placeholder-sm px-3 py-2 bg-gray-700 border border-transparent rounded placeholder-gray-111 text-black focus:outline-none active sm:text-sm" 
                        placeholder={t("Entrer le titre de votre lien")} 
                        required 
                      />
                    )}
                    {LanguageSelected === 'en' && (
                      <input 
                        value={LinksInfo.title?.en || ''}
                        onChange={(e) => AddingLinksInfo(e)} 
                        type="text" 
                        name="title-en" 
                        className="appearance-none block w-full placeholder-sm px-3 py-2 bg-gray-700 border border-transparent rounded placeholder-gray-111 text-black focus:outline-none active sm:text-sm" 
                        placeholder="Enter link title" 
                        required 
                      />
                    )}
                    {LanguageSelected === 'ar' && (
                      <input 
                        value={LinksInfo.title?.ar || ''}
                        onChange={(e) => AddingLinksInfo(e)} 
                        type="text" 
                        name="title-ar" 
                        dir="rtl"
                        className="appearance-none block w-full placeholder-sm px-3 py-2 bg-gray-700 border border-transparent rounded placeholder-gray-111 text-black focus:outline-none active sm:text-sm" 
                        placeholder="أدخل عنوان الرابط" 
                        required 
                      />
                    )}
                    <p className="mt-2 text-red-600 dark:text-red-500"><span className="font-xsmall">{InputsErrors.hasOwnProperty('title') && InputsErrors.title}</span></p>
                  </div>
                </div>

                {/* Multi-language Description Input */}
                <div>
                  <div className="mt-5">
                    {LanguageSelected === 'fr' && (
                      <textarea 
                        value={LinksInfo.description?.fr || ''}
                        rows={3} 
                        onChange={(e) => AddingLinksInfo(e)} 
                        name="description-fr" 
                        className="appearance-none block w-full placeholder-sm px-3 py-2 bg-gray-700 border border-transparent rounded placeholder-gray-111 text-black focus:outline-none active sm:text-sm" 
                        placeholder={t("Entrer la description de votre lien")} 
                      />
                    )}
                    {LanguageSelected === 'en' && (
                      <textarea 
                        value={LinksInfo.description?.en || ''}
                        rows={3} 
                        onChange={(e) => AddingLinksInfo(e)} 
                        name="description-en" 
                        className="appearance-none block w-full placeholder-sm px-3 py-2 bg-gray-700 border border-transparent rounded placeholder-gray-111 text-black focus:outline-none active sm:text-sm" 
                        placeholder="Enter link description" 
                      />
                    )}
                    {LanguageSelected === 'ar' && (
                      <textarea 
                        value={LinksInfo.description?.ar || ''}
                        rows={3} 
                        onChange={(e) => AddingLinksInfo(e)} 
                        name="description-ar" 
                        dir="rtl"
                        className="appearance-none block w-full placeholder-sm px-3 py-2 bg-gray-700 border border-transparent rounded placeholder-gray-111 text-black focus:outline-none active sm:text-sm" 
                        placeholder="أدخل وصف الرابط" 
                      />
                    )}
                    <p className="mt-2 text-red-600 dark:text-red-500"><span className="font-xsmall">{InputsErrors.hasOwnProperty('description') && InputsErrors.description}</span></p>
                  </div>
                </div>
              </div>
              
              <button onClick={(e) => StoreLinksInfo(e)} disabled={isFetching} type="submit" className={`w-full btn-edit ${isFetching ? 'opacity-50 cursor-not-allowed' : ''}`}>
                {isFetching ? t('Chargement...') : t("enregistrer")}
              </button>
            </form>
          </div>
        </div>
      </div>
    )}

    {/* Edit Modal */}
    {EditLinksModal &&
      LinksContent.map(link => {
        if (link.id === LinksId) {
          return (
            <div key={link.id}>
              <div className="minscreen h-full animated fadeIn faster fixed left-0 top-0 flex justify-center items-center inset-0 z-50 forms-info">
                <div className="absolute top-0 right-0 p-4">
                  <a className='w-12 h-12' onClick={() => { setEditLinksModal(false); seteditImage(false); setCroppedImage(null); setImageToCrop(null); setInputsErrors([]); }}>
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-theme cursor-pointer" viewBox="0 0 20 20" fill="currentColor">
                      <path fillRule="evenodd" d="M14.707 14.707a1 1 0 0 1-1.414 0L10 11.414l-3.293 3.293a1 1 0 1 1-1.414-1.414L8.586 10l-3.293-3.293a1 1 0 0 1 1.414-1.414L10 8.586l3.293-3.293a1 1 0 0 1 1.414 1.414L11.414 10l3.293 3.293a1 1 0 0 1 0 1.414z" />
                    </svg>
                  </a>
                </div>
                <div className="w-full max-w-sm p-8 rounded-md">
                  <h2 className="text-3xl text-theme mb-2">{t("Liens")}</h2>
                  <form className="space-y-6 text-about">
                    <div>
                      <label htmlFor="image" className="textModal">{t("Modifier votre lien vers un site ou un document hébergé pour permettre à vos réunions d'y accéder en un clic")}</label>
                      
                      {croppedImage && (
                        <div className='relative'>
                          <div className='w-44 h-44'>
                            <img className="cover w-full h-full preview-image rounded-xl mt-4" src={URL.createObjectURL(croppedImage)} alt="Preview" />
                          </div>
                          <a onClick={() => { setCroppedImage(null); setImageToCrop(null); }}>
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 absolute right-1 top-1 text-white div-sections opacity-50 rounded-xl cursor-pointer" viewBox="0 0 20 20" fill="currentColor">
                              <path fillRule="evenodd" d="M14.707 14.707a1 1 0 0 1-1.414 0L10 11.414l-3.293 3.293a1 1 0 1 1-1.414-1.414L8.586 10l-3.293-3.293a1 1 0 0 1 1.414-1.414L10 8.586l3.293-3.293a1 1 0 0 1 1.414 1.414L11.414 10l3.293 3.293a1 1 0 0 1 0 1.414z" />
                            </svg>
                          </a>
                        </div>
                      )}
                      
                      {link.image && !editImage && (
                        <div className='relative'>
                          <div className='w-44 h-44'>
                            <img className="cover w-full h-full preview-image rounded-xl mt-4" src={`${ImageUrl}/${hashedUserId}/${link.image}`} alt="Preview" />
                          </div>
                          <a onClick={() => { setCroppedImage(null); setImageToCrop(null); seteditImage(true); setLinksInfo({ ...LinksInfo, Image: '_DELETE' }) }}>
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 absolute right-1 top-1 text-white div-sections opacity-50 rounded-xl cursor-pointer" viewBox="0 0 20 20" fill="currentColor">
                              <path fillRule="evenodd" d="M14.707 14.707a1 1 0 0 1-1.414 0L10 11.414l-3.293 3.293a1 1 0 1 1-1.414-1.414L8.586 10l-3.293-3.293a1 1 0 0 1 1.414-1.414L10 8.586l3.293-3.293a1 1 0 0 1 1.414 1.414L11.414 10l3.293 3.293a1 1 0 0 1 0 1.414z" />
                            </svg>
                          </a>
                        </div>
                      )}

                      <div className="flex items-center justify-center w-full">
                        {((!link.image && !croppedImage) || (editImage && !croppedImage)) && (
                          <label htmlFor="dropzone-file-serviceEdit" className="flex flex-col items-center justify-center w-full h-44 mt-5 border-2 border-gold border-dashed rounded-lg cursor-pointer div-sections">
                            <div className="flex flex-col items-center justify-center pt-5 pb-6">
                              <svg aria-hidden="true" className="w-10 h-10 mb-3 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"></path>
                              </svg>
                              <center><p className="mb-2 text-sm text-gray-300"><span className="font-semibold">{t("Cliquez pour télécharger")}</span></p></center>
                              <p className="text-xs text-gray-400">SVG, PNG, JPG or GIF (MAX. 800x400px)</p>
                              <p className="mt-2 text-center text-red-600 dark:text-red-500"><span className="font-xsmall">{InputsErrors?.hasOwnProperty('image') && InputsErrors.image}</span></p>
                            </div>
                            <input onChange={(e) => { AddingLinkInfoImage(e) }} id="dropzone-file-serviceEdit" type="file" name='image' className="hidden" />
                          </label>
                        )}
                      </div>

                      <div className='mt-3'>
                        <div className="mt-5">
                          <input 
                            value={LinksInfo.url || ''}
                            onChange={(e) => { AddingLinksInfo(e) }} 
                            type="text" 
                            name="url" 
                            className="appearance-none block w-full placeholder-sm px-3 py-2 bg-gray-700 border border-transparent rounded placeholder-gray-111 text-black focus:outline-none active sm:text-sm" 
                            placeholder={t("Entrer votre URL*")} 
                            required 
                          />
                          <p className="mt-2 text-red-600 dark:text-red-500"><span className="font-xsmall">{InputsErrors.hasOwnProperty('url') && InputsErrors.url}</span></p>
                        </div>
                      </div>

                      {/* Multi-language Title Edit */}
                      <div>
                        <div className="mt-5">
                          {LanguageSelected === 'fr' && (
                            <input 
                              value={LinksInfo.title?.fr || ''}
                              onChange={(e) => AddingLinksInfo(e)} 
                              type="text" 
                              name="title-fr" 
                              className="appearance-none block w-full placeholder-sm px-3 py-2 bg-gray-700 border border-transparent rounded placeholder-gray-111 text-black focus:outline-none active sm:text-sm" 
                              placeholder={t("Entrer le titre de votre lien")} 
                              required 
                            />
                          )}
                          {LanguageSelected === 'en' && (
                            <input 
                              value={LinksInfo.title?.en || ''}
                              onChange={(e) => AddingLinksInfo(e)} 
                              type="text" 
                              name="title-en" 
                              className="appearance-none block w-full placeholder-sm px-3 py-2 bg-gray-700 border border-transparent rounded placeholder-gray-111 text-black focus:outline-none active sm:text-sm" 
                              placeholder="Enter link title" 
                              required 
                            />
                          )}
                          {LanguageSelected === 'ar' && (
                            <input 
                              value={LinksInfo.title?.ar || ''}
                              onChange={(e) => AddingLinksInfo(e)} 
                              type="text" 
                              name="title-ar" 
                              dir="rtl"
                              className="appearance-none block w-full placeholder-sm px-3 py-2 bg-gray-700 border border-transparent rounded placeholder-gray-111 text-black focus:outline-none active sm:text-sm" 
                              placeholder="أدخل عنوان الرابط" 
                              required 
                            />
                          )}
                          <p className="mt-2 text-red-600 dark:text-red-500"><span className="font-xsmall">{InputsErrors.hasOwnProperty('title') && InputsErrors.title}</span></p>
                        </div>
                      </div>

                      {/* Multi-language Description Edit */}
                      <div>
                        <div className="mt-5">
                          {LanguageSelected === 'fr' && (
                            <textarea 
                              value={LinksInfo.description?.fr || ''}
                              rows={3} 
                              onChange={(e) => AddingLinksInfo(e)} 
                              name="description-fr" 
                              className="appearance-none block w-full placeholder-sm px-3 py-2 bg-gray-700 border border-transparent rounded placeholder-gray-111 text-black focus:outline-none active sm:text-sm" 
                              placeholder={t("Entrer la description de votre lien")} 
                            />
                          )}
                          {LanguageSelected === 'en' && (
                            <textarea 
                              value={LinksInfo.description?.en || ''}
                              rows={3} 
                              onChange={(e) => AddingLinksInfo(e)} 
                              name="description-en" 
                              className="appearance-none block w-full placeholder-sm px-3 py-2 bg-gray-700 border border-transparent rounded placeholder-gray-111 text-black focus:outline-none active sm:text-sm" 
                              placeholder="Enter link description" 
                            />
                          )}
                          {LanguageSelected === 'ar' && (
                            <textarea 
                              value={LinksInfo.description?.ar || ''}
                              rows={3} 
                              onChange={(e) => AddingLinksInfo(e)} 
                              name="description-ar" 
                              dir="rtl"
                              className="appearance-none block w-full placeholder-sm px-3 py-2 bg-gray-700 border border-transparent rounded placeholder-gray-111 text-black focus:outline-none active sm:text-sm" 
                              placeholder="أدخل وصف الرابط" 
                            />
                          )}
                          <p className="mt-2 text-red-600 dark:text-red-500"><span className="font-xsmall">{InputsErrors.hasOwnProperty('description') && InputsErrors.description}</span></p>
                        </div>
                      </div>
                    </div>
                    
                    <button onClick={(e) => UpdateLinksInfo(e)} disabled={isFetching} type="submit" className={`w-full btn-edit ${isFetching ? 'opacity-50 cursor-not-allowed' : ''}`}>
                      {isFetching ? t('Chargement...') : t("enregistrer")}
                    </button>
                  </form>
                </div>
              </div>
            </div>
          );
        }
        return null;
      })
    }

    {/* Crop Image Modal */}
    {CropImage && (
      <div>
        <div className="minscreen overflow-auto h-full animated fadeIn faster fixed left-0 top-0 flex justify-center items-center inset-0 z-1000 forms-info">
          <div className="absolute top-0 right-0 p-4">
            <a className='w-12 h-12' onClick={() => {
              setCropImage(false); setCroppedImage(null);
              setImageToCrop(null);
              setZoom(1)
            }}>
              <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-theme cursor-pointer" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M14.707 14.707a1 1 0 0 1-1.414 0L10 11.414l-3.293 3.293a1 1 0 1 1-1.414-1.414L8.586 10l-3.293-3.293a1 1 0 0 1 1.414-1.414L10 8.586l3.293-3.293a1 1 0 0 1 1.414 1.414L11.414 10l3.293 3.293a1 1 0 0 1 0 1.414z" />
              </svg>
            </a>
          </div>
          <div className="w-full text-about settingswidth p-8">
            <div className="flex flex-col items-left justify-start mt-8">
              <p className="text-md text-gold">{t("Recadrez votre photo pour un meilleur rendu")}</p>
            </div>

            <div className='flex flex-col items-center justify-center p-6'>
              {imageToCrop && (
                <div className="crop-container w-full">
                  <Cropper
                    image={imageToCrop}
                    crop={crop}
                    zoom={zoom}
                    aspect={4 / 4}
                    onCropChange={onCropChange}
                    onZoomChange={onZoomChange}
                    onCropComplete={handleCropComplete}
                  />
                </div>
              )}
              <div className="controls">
                <label htmlFor="zoom-input" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Zoom : </label>
                <input 
                  id="zoom-input" 
                  type="range"
                  min={1}
                  max={3}
                  step={0.1}
                  value={zoom}
                  onChange={(e) => onZoomChange(parseFloat(e.target.value))}
                  className="w-full h-2 mb-6 bg-gray-200 rounded-lg appearance-none cursor-pointer text-gold" 
                />
              </div>
              {croppedImage && (
                <div className="cropped-image-container">
                  <div className="flex flex-col items-left justify-start mt-2 mb-4">
                    <p className="text-md text-gold">{t("Image Recadrer")}</p>
                  </div>
                  <div className='crop-image'>
                    <img src={URL.createObjectURL(croppedImage)} alt="Cropped" />
                  </div>
                </div>
              )}
            </div>

            <div>
              <button
                onClick={(e) => { setCropImage(false); Base64Image() }}
                type="submit"
                className="w-full btn-edit"
              >
                {t("enregistrer")}
              </button>
            </div>
          </div>
        </div>
      </div>
    )}
  </div>
)
}

export default LinksEdit